import { useQuery, type UseQueryOptions } from '@lumapps/base-api/react-query';
import { useSelector } from '@lumapps/redux/react';
import { connectedUserSelector, isMicrosoftAccount } from '@lumapps/user/ducks/selectors';

import { BatchOneDriveFilesRequestParam, getBatchOneDriveFilesApi, oneDriveQueryKeys } from '../../api';

export function useGetOneDriveFiles(apiParams?: BatchOneDriveFilesRequestParam, queryOptions?: UseQueryOptions) {
    const user = useSelector(connectedUserSelector);
    const { token } = user || {};

    const isMicrosoftUser = useSelector(isMicrosoftAccount);
    const params = { ...apiParams, isMicrosoftUser, token };

    return useQuery({
        queryKey: oneDriveQueryKeys['batch-files'](params),
        queryFn: async ({ signal }) => getBatchOneDriveFilesApi(params, signal),
        enabled: isMicrosoftUser && Number(apiParams?.files?.length) > 0 && (queryOptions?.enabled ?? true),
        ...queryOptions,
    });
}
